const dialog = document.querySelector("dialog");
const showButton = document.querySelector("dialog + button");
const closeButton = document.querySelector("#closeButton");

if(showButton) {
  showButton.addEventListener("click", () => {
    dialog.showModal();
  });
}

if(closeButton) {
  closeButton.addEventListener("click", () => {
    dialog.close();
  });
}
